import * as React from "react";
import type { SVGProps } from "react";
const SvgFolderSearch01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m14.4 15.6 1.2 1.2m-13.2.741.001-9.124V5.258a1.2 1.2 0 0 1 1.2-1.2h5.718l2.765 2.954H20.4a1.2 1.2 0 0 1 1.2 1.2v9.33a2.4 2.4 0 0 1-2.4 2.4L4.8 19.94a2.4 2.4 0 0 1-2.4-2.4M15 13.2a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    />
  </svg>
);
export default SvgFolderSearch01;
